var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.$emit("create", _vm.form)
        },
      },
    },
    [
      _c("div", { staticClass: "emd-form-group" }, [
        _c("label", { staticClass: "emd-label _required lable_title" }, [
          _vm._v(" " + _vm._s(_vm.$t("form.name")) + " "),
        ]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.name,
              expression: "form.name",
            },
          ],
          staticClass: "emd-input",
          attrs: { placeholder: _vm.$t("form.name.placeholder"), type: "text" },
          domProps: { value: _vm.form.name },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.form, "name", $event.target.value)
            },
          },
        }),
      ]),
      _c(
        "div",
        { staticClass: "emd-form-group" },
        [
          _c("jade-checkbox", {
            attrs: {
              id: "checkbox",
              value: _vm.form.isLegacy,
              label: _vm.$t("form.checkbox"),
            },
            on: {
              "update:value": function ($event) {
                return _vm.$set(_vm.form, "isLegacy", $event)
              },
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "eu-pb_4" }, [
        _c("label", { staticClass: "emd-label lable_title" }, [
          _vm._v(" " + _vm._s(_vm.$t("form.type.title")) + " "),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "eu-pb_4" },
        [
          _c("emd-radio", {
            staticClass: "eu-mb_1 _bold",
            attrs: {
              name: "radio",
              value: "all",
              label: _vm.$t(`form.type.all.label`),
            },
            model: {
              value: _vm.form.type,
              callback: function ($$v) {
                _vm.$set(_vm.form, "type", $$v)
              },
              expression: "form.type",
            },
          }),
          _c(
            "emd-text",
            {
              staticClass: "eu-ml_5",
              attrs: { size: "small", tag: "p", "variation-color": "subtle" },
            },
            [_vm._v(_vm._s(_vm.$t(`form.type.all.description`)))]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "eu-pb_4" },
        [
          _c("emd-radio", {
            staticClass: "eu-mb_1 _bold",
            attrs: {
              name: "radio",
              value: "custom",
              label: _vm.$t(`form.type.custom.label`),
            },
            model: {
              value: _vm.form.type,
              callback: function ($$v) {
                _vm.$set(_vm.form, "type", $$v)
              },
              expression: "form.type",
            },
          }),
          _c(
            "emd-text",
            {
              staticClass: "eu-ml_5",
              attrs: { size: "small", tag: "p", "variation-color": "subtle" },
            },
            [_vm._v(_vm._s(_vm.$t(`form.type.custom.description`)))]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "create-key__footer" },
        [
          _c(
            "emd-button",
            {
              attrs: {
                type: "outline",
                color: "primary",
                "data-testid": "close-modal",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("form.button.close")) + " ")]
          ),
          _c(
            "emd-button",
            {
              attrs: {
                color: "primary",
                "data-testid": "next",
                type: "submit",
                disabled: _vm.$v.form.$invalid,
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("form.button.next")) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }